<template>
  <div class="select-columns">
    <b-dropdown
      size="lg"
      variant="link"
      class="position-initial"
      toggle-class="text-decoration-none"
      no-flip
      col
      :menu-class="{
        'content-dropdown-menu': true,
        'ul-1-columns': fieldsLocal.length <= 10,
        'ul-2-columns': fieldsLocal.length > 10 && fieldsLocal.length <= 20,
        'ul-3-columns': fieldsLocal.length > 20,
      }"
      no-caret
    >
      <template #button-content>
        <span>
          <img
            src="@/assets/icons/add-columnas-icon.svg"
            alt="Add columnas icon"
            class="icon-add-columnas ml-3"
          />
        </span>
      </template>
      <b-dropdown-item-button
        :class="{ 'field-not-visible': !allVisible, field: true }"
        @click="setAllVisible"
      >
        <b-icon v-if="allVisible" icon="check"></b-icon>
        <span class="text-uppercase">{{ $t("label.todos") }}</span>
      </b-dropdown-item-button>
      <template v-for="field in fieldsLocal">
        <b-dropdown-item-button
          :class="{ 'field-not-visible': !field.visible, field: true }"
          v-if="!field.aux"
          :key="field.key"
          @click.native.capture.stop="toggle(field)"
        >
          <b-icon v-if="field.visible" icon="check"></b-icon>
          {{ field.label }}
        </b-dropdown-item-button>
      </template>
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { IField, IFields, ISoConfColumnasUpdateDTO } from "@/entities";
import { Action } from "vuex-class";
import { IColumnaResponse, IPaged } from "@/services";

@Component
export default class SelectColumns extends Vue {
  @Prop({ required: true, default: [] }) fields!: IFields;
  @Prop({ required: true, default: null }) pagination: IPaged | undefined;
  @Prop({ required: true, default: "" }) codTable!: string;
  @Action("saveColumna")
  saveColumna!: (params: ISoConfColumnasUpdateDTO) => Promise<IColumnaResponse | undefined>;

  get fieldsLocal(): IFields {
    return this.fields;
  }

  get allVisible(): boolean {
    return this.fields.filter((f) => !(f as IField).visible).length === 0;
  }

  get visibleColumnsKey(): string {
    if ((this.fieldsLocal[1] as IField).code) {
      return this.fieldsLocal
        .filter((f) => (f as IField).visible && !(f as IField).aux)
        .map((f) => (f as IField).code)
        .toString();
    } else {
      return this.fieldsLocal
        .filter((f) => (f as IField).visible && !(f as IField).aux)
        .map((f) => (f as IField).key)
        .toString();
    }
  }

  toggle(field: string | IField): void {
    if (typeof field !== "string") {
      if ((this.fieldsLocal[1] as IField).code) {
        this.$emit(
          "update:fields",
          this.fieldsLocal.map((f) => {
            if ((f as IField).code === field.code) {
              (f as IField).visible = !(f as IField).visible;
            }
            return f;
          })
        );
      } else {
        this.$emit(
          "update:fields",
          this.fieldsLocal.map((f) => {
            if ((f as IField).key === field.key) {
              (f as IField).visible = !(f as IField).visible;
            }
            return f;
          })
        );
      }

      this.save();
    }
  }

  setAllVisible(): void {
    this.$emit(
      "update:fields",
      this.fieldsLocal.map((f) => {
        (f as IField).visible = true;
        return f;
      })
    );
    this.save();
  }

  async save(): Promise<void> {
    const params: ISoConfColumnasUpdateDTO = {
      codColumna: this.visibleColumnsKey,
      codTabla: this.codTable,
    };
    if (this.pagination) {
      params.codTipoOrden = this.pagination.direction;
      params.numPagElements = this.pagination.size;
      params.codOrden = this.pagination.orderBy;
    }
    await this.saveColumna(params);
  }
}
</script>

//No se puede poner scoped
<style lang="scss">
.select-columns {
  .field-not-visible {
    padding-left: 19px;
  }

  .field {
    font-size: 0.8rem;
  }

  .field:hover {
    background-color: var(--amarillo-prosegur);
  }

  .dropdown-item:hover {
    color: #16181b;
    text-decoration: none;
    background-color: var(--amarillo-prosegur);
  }

  .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: transparent;
  }

  .content-dropdown-menu {
    border-color: var(--amarillo-prosegur);
    left: initial !important;
    right: 1em !important;
    top: 2em !important;
    transform: none !important;
  }

  .position-initial {
    position: initial;
  }

  .ul-3-columns {
    columns: 3;
  }

  .ul-2-columns {
    columns: 2;
  }

  .ul-1-columns {
    columns: 1;
  }
}
</style>
